import {
  Box,
  Image,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { IoEllipseSharp, IoImageOutline } from "react-icons/io5";
import { useGetState } from "../../context/useGetState";
import { photoBaseURL } from "../../service/api";
import { db } from "../../service/firebase";
import { trunc } from "../../utils";
import thelogo from "../../assets/thelogo.png";
import { useParams } from "react-router";
var relativeTime = require("dayjs/plugin/relativeTime");
let utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
dayjs.extend(relativeTime);

function formatDate(created_at) {
  const currentDate = new Date();
  const createdAtDate = new Date(created_at);

  // Get the time in format 3:48 if created today
  if (
    currentDate.getDate() === createdAtDate.getDate() &&
    currentDate.getMonth() === createdAtDate.getMonth() &&
    currentDate.getFullYear() === createdAtDate.getFullYear()
  ) {
    const hours = createdAtDate.getHours();
    const minutes = createdAtDate.getMinutes();
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
  }
}
  
function ExternalUserChatProfile({ chat, serverChat, onlineUsers, socketLastObj, incomingLastMessage }) {
    const { state } = useGetState();
  
    const usernameColor = useColorModeValue("#4B5155", "#526075");
    const [isTyping, setIsTyping] = useState({});
   
    const { privateUserId } = useParams();
    //console.log('incomingLastMessage: ', incomingLastMessage);
    

    //update the 'last_message' property of a 'user' object with data from 'incomingLastMessage'
  // if (incomingLastMessage) {
  //   if (parseFloat((incomingLastMessage?.sender_id) === parseFloat(chat?.sender_id)) && parseFloat((incomingLastMessage?.recipient_id) === parseFloat(chat?.recipient_id))) {
  //     chat.last_message = {
  //       ...(chat.last_message || {}), // Ensure group.last_message is an object
  //       message: incomingLastMessage.message,
  //       file: incomingLastMessage.file,
  //       sender_id: incomingLastMessage.sender_id,
  //       recipient_id: incomingLastMessage.recipient_id,
  //       created_at: incomingLastMessage.created_at,
  //       read_at: incomingLastMessage.read_at,
  //     };
  //   }
  // }

    //////////////used one////////////////////////
    const updatedChat = { ...chat };

    if (socketLastObj !== undefined) {
      updatedChat.last_message = {
        ...updatedChat?.last_message,
        message: socketLastObj?.message,
        file: socketLastObj?.file,
        sender_id: socketLastObj?.sender_id,
        recipient_id: socketLastObj?.recipient_id,
        created_at: socketLastObj?.created_at,
        read_at: socketLastObj?.read_at,
      };
    }

    //console.log('serverChat: ', serverChat);

    const getLastMessage = (chat, socketLastObj) => {
      return socketLastObj?.recipient_id === chat?.recipient?.id ? socketLastObj : chat?.last_message;
    };

    return (
      <Stack direction={"row"} alignItems="flex-start">
        <Box style={{ position:"relative" }}>
          <Image
            w="30px"
            h="30px"
            borderRadius={"50%"}
            objectFit="cover"
            //border={"2px solid #fff"}
            size={"sm"}
            name={privateUserId ? updatedChat?.name : updatedChat?.recipient?.name}
            fallbackSrc={thelogo}
            src={privateUserId ? updatedChat?.picture : updatedChat?.recipient?.picture}
          />
          <Box style={{ position:"absolute", bottom:"0px", right:"0px", color:"green", border:"1px solid #fff", borderRadius:"50%", backgroundColor:"#fff" }}>
          {
            onlineUsers?.some((user) => user?.userId === parseFloat(privateUserId) || user?.userId === updatedChat?.id) ? 
            <IoEllipseSharp style={{ color:"green" }} size={7}/> :
            <IoEllipseSharp style={{ color:"lightgray" }}/>
          }
          </Box>

        </Box>
        <Stack alignItems={"flex-start"} spacing="-0.5">
          <Text color={usernameColor} fontSize=".8em">
            {privateUserId ? updatedChat?.name : updatedChat?.recipient?.name} 
          </Text>
  
          {/* last message if*/}
          {updatedChat?.last_message?.message !== 'null' ? (
            <Tooltip label={updatedChat?.last_message?.message}>
              <Text color="#7B8793" fontSize={".66em"}>
                {socketLastObj?.recipient_id == updatedChat?.recipient?.id
                  ? trunc(updatedChat?.last_message?.message, 20)
                  : serverChat?.last_message?.message && serverChat?.last_message?.message !== 'null' ? trunc(serverChat?.last_message?.message, 20) : <IoImageOutline fontSize={"1em"} color="#afbbc6" /> 
                  }
              </Text>
            </Tooltip>
          ) : (socketLastObj?.recipient_id == updatedChat?.recipient?.id) ? (
            <IoImageOutline fontSize={"1em"} color="#afbbc6" />
          ) : serverChat?.last_message?.file ? <IoImageOutline fontSize={"1em"} color="#afbbc6" /> : <Text color="#7B8793" fontSize={".66em"}>{trunc(serverChat?.last_message?.message, 20)}</Text>}

        </Stack>
  
        {updatedChat?.last_message?.created_at ? (
          <Text color="#7B8793" fontSize={".7em"} flex="3" textAlign={"right"}>
            {/* {formatDate(updatedChat?.last_message?.created_at)} */}
            { socketLastObj?.recipient_id == updatedChat?.recipient?.id ? formatDate(updatedChat?.last_message?.created_at) : formatDate(serverChat?.last_message?.created_at) }
          </Text>
        ) : (
          ""
        )}

        
        {/* {numberOfUnseenMessage && <Text>{numberOfUnseenMessage}</Text>} */}

      {/* {chat?.last_message?.created_at && (
        <Text color="#7B8793" fontSize={".7em"} flex="3" textAlign={"right"}>
          {formatDate(chat?.last_message?.created_at)}
        </Text>
      )} */}
    </Stack>
  );
}

export default ExternalUserChatProfile;
